var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTapIcon = function SvgTapIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.626 9.449V2.308c0-2.02 2.32-3.061 3.734-1.677L18.3 5.47c1.46 1.43.486 3.98-1.52 3.98H9.627v7.243c0 2.004-2.29 3.052-3.711 1.7L.724 13.45C-.766 12.032.199 9.45 2.22 9.45h7.406Z",
    fill: "#3C4853"
  })));
};

export default SvgTapIcon;